import { render, staticRenderFns } from "./LenderCorporateStats.vue?vue&type=template&id=7fc22785&"
import script from "./LenderCorporateStats.vue?vue&type=script&lang=js&"
export * from "./LenderCorporateStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports